import { render, staticRenderFns } from "./BrandsTab.vue?vue&type=template&id=59318c5b"
import script from "./BrandsTab.vue?vue&type=script&lang=ts"
export * from "./BrandsTab.vue?vue&type=script&lang=ts"
import style0 from "./BrandsTab.vue?vue&type=style&index=0&id=59318c5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports